exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3ko9eaqBVVtlIY7skA5U5V{height:52px!important;width:44px!important}html[dir] ._3ko9eaqBVVtlIY7skA5U5V:hover{background:var(--neutralLighter)}", ""]);
// Exports
exports.locals = {
	"personaSuggestionIconButton": "_3ko9eaqBVVtlIY7skA5U5V"
};